import React, { PureComponent } from "react";
import { Collapse, Card, CardBody } from "reactstrap";
import axios from "axios";
import parseDate from "../../../helpers/parseDate";
import { CLOUDINARY_THUMB } from "../../../helpers/cloudinaryConstants";

export default class UserResult extends PureComponent {
  constructor(props) {
    super(props);
    this.parseRole = this.parseRole.bind(this);
    this.loggedInUser = JSON.parse(sessionStorage.getItem("user"));
    this.userRole = this.parseRole();
    this.isSuperAdmin = this.loggedInUser.privyData.group.goNation.some(
      role => role.name === "SuperAdmin"
    );
    this.onRemoveClick = this.onRemoveClick.bind(this);
    this.onRoleClick = this.onRoleClick.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.verifyEmail = this.verifyEmail.bind(this);
  }

  parseRole() {
    const { group } = this.props.user.privyData;

    if (group.goNation.length) {
      return group.goNation[0].name;
    }

    if (group.businesses.own.length) {
      return "Business Owner";
    }

    if (group.businesses.manage.length) {
      return "Business Manager";
    }

    return "User";
  }

  canBeRemoved() {
    switch (this.userRole) {
      case "Business Owner":
      case "Business Manager":
      case "Publisher":
        return true;
      case "Admin":
        if (this.isSuperAdmin) {
          return true;
        }
        return false;
      default:
        return false;
    }
  }

  onRoleClick(e) {
    e.stopPropagation();
    this.props.showBusinessRoleModal();
  }

  onRemoveClick(e) {
    e.stopPropagation();
    if (this.userRole === "Admin") {
      return this.props.onRemoveClick(this.props.user.id, this.userRole);
    }

    if (this.userRole === "Publisher") {
      const options = this.props.user.privyData.group.businesses.publish;
      return this.props.onRemoveClick(
        this.props.user.id,
        this.userRole,
        options
      );
    }

    if (this.userRole === "Business Owner") {
      const options = this.props.user.privyData.group.businesses.own;
      return this.props.onRemoveClick(
        this.props.user.id,
        this.userRole,
        options
      );
    }

    if (this.userRole === "Business Manager") {
      const options = this.props.user.privyData.group.businesses.manage;
      return this.props.onRemoveClick(
        this.props.user.id,
        this.userRole,
        options
      );
    }
  }

  verifyEmail(e) {
    e.stopPropagation();
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    axios
      .put(
        `/api/proxy/v2/users/${this.props.user.id}/emailverification`,
        {},
        { headers }
      )
      .then(() => {
        this.props.onSuccess();
      })
      .catch(err => {
        console.log(err);
        this.props.onFailure();
      });
  }

  resetPassword(e) {
    e.stopPropagation();
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    axios
      .put(
        `/api/proxy/v2/users/${this.props.user.id}/resetpassword`,
        {},
        { headers }
      )
      .then(() => {
        this.props.onSuccess();
      })
      .catch(err => {
        console.log(err);
        this.props.onFailure();
      });
  }

  render() {
    return (
      <tr key="tr" className="user-table__item" onClick={this.props.showModal}>
        <td className="text-center">
          <div className="avatar">
            <img
              src={`${CLOUDINARY_THUMB}/${
                this.props.user.avatar.image.cloudinaryId
              }`}
              className="img-avatar"
              alt={this.props.user.username}
            />
          </div>
        </td>
        <td>
          <div>{this.props.user.username}</div>
          <div className="small text-muted">
            Registered: {parseDate(this.props.user.createdAt)}
          </div>
        </td>
        <td>
          <div>{this.props.user.privyData.email} </div>
          <div onClick={this.verifyEmail} style={{ color: "#20bed6" }}>
            Verify Email
          </div>
          <div onClick={this.resetPassword} style={{ color: "#20bed6" }}>
            Reset Password
          </div>
        </td>
        <td onClick={this.onRoleClick} className="text-center">
          <div className="user-table-item__role">
            <a style={{ color: "#20bed6" }}>{this.userRole} </a>
            {this.canBeRemoved() && (
              <i onClick={this.onRemoveClick} className="icon-close" />
            )}
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Pages/Users/UserResult.js